<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-5 w-5 stroke-slate-500"
    :class="customStyle"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <path d="M9 15l6 -6" />
    <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
    <path
      d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"
    />
  </svg>
</template>

<script>
export default {
  name: 'LinkIcon2',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
